
interface PricingCardProps {
  title: string;
  price: string;
  originalPrice?: string;
  description: string;
  features: string[];
  isPopular?: boolean;
  onSelect: () => void;
  isProcessing?: boolean;
  loading?: boolean;
}

export function PricingCard({
  title,
  price,
  originalPrice,
  description,
  features,
  isPopular = false,
  onSelect,
  isProcessing = false,
  loading = false
}: PricingCardProps) {
  return (
    <div className={`relative bg-white rounded-2xl shadow-xl p-8 ${isPopular ? 'ring-4 ring-yellow-400 scale-105' : ''}`}>
      {isPopular && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <span className="bg-yellow-400 text-black px-6 py-2 rounded-full text-sm font-bold whitespace-nowrap">
            Most Popular
          </span>
        </div>
      )}

      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-gray-900 mb-4">{title}</h3>
        <div className="mb-4">
          {originalPrice && (
            <span className="text-lg text-gray-500 line-through mr-2">{originalPrice}</span>
          )}
          <span className="text-4xl font-bold text-gray-900">{price}</span>
        </div>
        <p className="text-gray-600 leading-relaxed">{description}</p>
      </div>

      <ul className="space-y-4 mb-8">
        {features.map((feature, index) => (
          <li key={index} className="flex items-start">
            <i className="ri-check-line text-green-500 mr-3 mt-1 flex-shrink-0"></i>
            <span className="text-gray-700 leading-relaxed">{feature}</span>
          </li>
        ))}
      </ul>

      <button
        onClick={onSelect}
        disabled={isProcessing}
        className={`w-full py-4 px-6 rounded-full font-bold text-lg transition-all duration-300 whitespace-nowrap ${
          isProcessing 
            ? 'opacity-50 cursor-not-allowed bg-gray-400 text-white' 
            : isPopular
              ? 'bg-gradient-to-r from-yellow-400 to-yellow-500 text-black hover:from-yellow-500 hover:to-yellow-600 hover:shadow-lg hover:scale-105 cursor-pointer'
              : 'bg-gray-900 text-white hover:bg-gray-800 hover:shadow-lg hover:scale-105 cursor-pointer'
        }`}
      >
        {loading ? (
          <span className="flex items-center justify-center">
            <i className="ri-loader-4-line animate-spin mr-2"></i>
            Creating Session...
          </span>
        ) : (
          <span className="flex items-center justify-center">
            Choose This Plan
            <i className="ri-arrow-right-line ml-2"></i>
          </span>
        )}
      </button>

      {isPopular && (
        <div className="text-center mt-4">
          <p className="text-sm text-gray-500">
            <i className="ri-shield-check-line text-green-500 mr-1"></i>
            30-day money-back guarantee
          </p>
        </div>
      )}
    </div>
  );
}
